export default __webpack_public_path__ + "static/media/flash-hider-flat.ef0ae7ed.svg";